import './_add-card-modal.scss';
import component from './add-card-modal';

export default component;
